import {Activity} from 'types';

export const status = (activity: Activity | undefined, timestamp?: number) => {
  if (activity?.repeatType && activity?.status === 'Completed') {
    return 'Cancelled';
  } else if (activity?.status === 'Completed') {
    return 'Completed';
  } else if (activity?.status === 'On Hold' || (activity?.repeatType && !activity.scheduleDate)) {
    return 'On Hold';
  } else if (timestamp && activity?.repeatType && activity.endDate && activity.endDate < timestamp) {
    return 'Expired';
  } else if (timestamp && activity?.repeatType && activity.scheduleDate && activity.scheduleDate > timestamp) {
    return 'Future';
  }
  return 'Not Started';
};
